// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"SeatListRowPriceHeader__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/AirlineSeatSelection/SeatListRowPriceHeader.scss
 ** module id = 882
 ** module chunks = 1
 **/